import React, { lazy } from 'react';
import { LightbulbIcon, QuoteIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const EDISON_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/hbMB55uJazCbnD5PPr9HxR/Mod1-1_page-0001.webp';
export function StoryEdison() {
  return <section className="py-12 md:py-16 bg-background relative overflow-hidden" aria-label="La historia que cambia todo" data-id="element-495">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-496">
        <FadeIn data-id="element-497">
          <div className="bg-white rounded-3xl border border-slate-100 shadow-soft-lg overflow-hidden" data-id="element-498">
            <div className="grid md:grid-cols-5 gap-0" data-id="element-499">
              {/* Image */}
              <div className="md:col-span-2 relative" data-id="element-500">
                <img src={EDISON_IMAGE_URL} alt="Ilustración de Thomas Edison — la historia que reencuadra el error como aprendizaje" className="w-full h-56 md:h-full object-cover object-top" width={600} height={800} loading="lazy" decoding="async" data-id="element-501" />
              </div>

              {/* Text */}
              <div className="md:col-span-3 p-6 md:p-8" data-id="element-502">
                <span className="inline-flex items-center gap-2 px-3 py-1 mb-3 rounded-full border border-primary/30 bg-primary/10 text-primary-dark text-[10px] font-bold uppercase tracking-widest" data-id="element-503">
                  <LightbulbIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-504" />
                  La historia que cambia todo
                </span>

                <div className="relative pl-4 border-l-4 border-primary/40 mb-4" data-id="element-505">
                  <QuoteIcon className="w-5 h-5 text-primary/30 mb-1" aria-hidden="true" data-id="element-506" />
                  <p className="text-slate-700 text-sm md:text-base leading-snug" data-id="element-507">
                    Thomas Edison intentó crear la bombilla más de 1.000 veces.
                    Cuando le preguntaron si se sentía mal por fallar tanto,
                    respondió:{' '}
                    <strong className="text-slate-900 font-bold" data-id="element-508">
                      "No fallé 1.000 veces. Aprendí 1.000 formas en que no
                      funciona."
                    </strong>
                  </p>
                </div>

                <p className="text-slate-600 text-sm md:text-base leading-snug mb-4" data-id="element-509">
                  La próxima vez que tu hijo diga{' '}
                  <em className="text-slate-800" data-id="element-510">
                    "soy malo para las matemáticas"
                  </em>
                  , contale esta historia. Después preguntale:{' '}
                  <em className="text-slate-800" data-id="element-511">
                    "¿Cuántos intentos llevás hoy?"
                  </em>
                </p>

                <div className="flex items-start gap-2.5 bg-primary/[0.06] border border-primary/15 rounded-2xl px-4 py-3" data-id="element-512">
                  <span className="text-base shrink-0" aria-hidden="true" data-id="element-513">
                    💡
                  </span>
                  <p className="text-slate-700 text-xs md:text-sm leading-snug font-medium" data-id="element-514">
                    Esta pequeña conversación reencuadra el error como
                    información útil, no como evidencia de fracaso. Los niños
                    absorben ese lenguaje y empiezan a usarlo solos.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}